import {
  faAnchor,
  faBed,
  faBell,
  faBicycle,
  faBinoculars,
  faBirthdayCake,
  faBlender,
  faBone,
  faBook,
  faBox,
  faBriefcase,
  faBug,
  faBuilding,
  faBullhorn,
  faBullseye,
  faBus,
  faCalendar,
  faCamera,
  faCampground,
  faCar,
  faCarrot,
  faCat,
  faChair,
  faChartLine,
  faChartPie,
  faChess,
  faCheck,
  faChild,
  faCircle,
  faClipboard,
  faCloud,
  faCloudRain,
  faCloudSun,
  faClock,
  faCoffee,
  faCog,
  faCoins,
  faCompass,
  faCouch,
  faCreditCard,
  faCube,
  faCubes,
  faCut,
  faDatabase,
  faDesktop,
  faDice,
  faDrum,
  faDog,
  faDumbbell,
  faEnvelope,
  faEraser,
  faEuroSign,
  faEye,
  faEyeSlash,
  faFan,
  faFire,
  faFireExtinguisher,
  faFish,
  faFlag,
  faFlagCheckered,
  faFlask,
  faFolder,
  faFootballBall,
  faGamepad,
  faGem,
  faGraduationCap,
  faGuitar,
  faHamburger,
  faHeadphones,
  faHeart,
  faHome,
  faLaptop,
  faLeaf,
  faLightbulb,
  faMobileAlt,
  faPaintBrush,
  faPlane,
  faRing,
  faStar,
  faTrophy,
  faTshirt,
  faUtensils,
  faWater,
  faWrench,
} from '@fortawesome/free-solid-svg-icons';

export interface IconOption {
  name: string;
  key: string;
  icon: any;
}

export const availableIcons: IconOption[] = [
  { name: 'Laptop', key: 'faLaptop', icon: faLaptop },
  { name: 'Chair', key: 'faChair', icon: faChair },
  { name: 'Book', key: 'faBook', icon: faBook },
  { name: 'T-Shirt', key: 'faTshirt', icon: faTshirt },
  { name: 'Ring', key: 'faRing', icon: faRing },
  { name: 'Football', key: 'faFootballBall', icon: faFootballBall },
  { name: 'Paintbrush', key: 'faPaintBrush', icon: faPaintBrush },
  { name: 'Wrench', key: 'faWrench', icon: faWrench },
  { name: 'Car', key: 'faCar', icon: faCar },
  { name: 'Camera', key: 'faCamera', icon: faCamera },
  { name: 'Gamepad', key: 'faGamepad', icon: faGamepad },
  { name: 'Guitar', key: 'faGuitar', icon: faGuitar },
  { name: 'Home', key: 'faHome', icon: faHome },
  { name: 'Heart', key: 'faHeart', icon: faHeart },
  { name: 'Dumbbell', key: 'faDumbbell', icon: faDumbbell },
  { name: 'Utensils', key: 'faUtensils', icon: faUtensils },
  { name: 'Coffee', key: 'faCoffee', icon: faCoffee },
  { name: 'Plane', key: 'faPlane', icon: faPlane },
  { name: 'Bicycle', key: 'faBicycle', icon: faBicycle },
  { name: 'Lightbulb', key: 'faLightbulb', icon: faLightbulb },
  { name: 'Mobile', key: 'faMobileAlt', icon: faMobileAlt },
  { name: 'Headphones', key: 'faHeadphones', icon: faHeadphones },
  { name: 'Graduation Cap', key: 'faGraduationCap', icon: faGraduationCap },
  { name: 'Dog', key: 'faDog', icon: faDog },
  { name: 'Bus', key: 'faBus', icon: faBus },
  { name: 'Clock', key: 'faClock', icon: faClock },
  { name: 'Box', key: 'faBox', icon: faBox },
  { name: 'Star', key: 'faStar', icon: faStar },
  { name: 'Gem', key: 'faGem', icon: faGem },
  { name: 'Leaf', key: 'faLeaf', icon: faLeaf },
  { name: 'Fire', key: 'faFire', icon: faFire },
  { name: 'Water', key: 'faWater', icon: faWater },
  { name: 'Trophy', key: 'faTrophy', icon: faTrophy },
  { name: 'Cube', key: 'faCube', icon: faCube },
  { name: 'Anchor', key: 'faAnchor', icon: faAnchor },
  { name: 'Bed', key: 'faBed', icon: faBed },
  { name: 'Bell', key: 'faBell', icon: faBell },
  { name: 'Binoculars', key: 'faBinoculars', icon: faBinoculars },
  { name: 'Blender', key: 'faBlender', icon: faBlender },
  { name: 'Bone', key: 'faBone', icon: faBone },
  { name: 'Briefcase', key: 'faBriefcase', icon: faBriefcase },
  { name: 'Bug', key: 'faBug', icon: faBug },
  { name: 'Building', key: 'faBuilding', icon: faBuilding },
  { name: 'Bullhorn', key: 'faBullhorn', icon: faBullhorn },
  { name: 'Bullseye', key: 'faBullseye', icon: faBullseye },
  { name: 'Burger', key: 'faHamburger', icon: faHamburger },
  { name: 'Cake', key: 'faBirthdayCake', icon: faBirthdayCake },
  { name: 'Calendar', key: 'faCalendar', icon: faCalendar },
  { name: 'Campground', key: 'faCampground', icon: faCampground },
  { name: 'Carrot', key: 'faCarrot', icon: faCarrot },
  { name: 'Cat', key: 'faCat', icon: faCat },
  { name: 'Chart Line', key: 'faChartLine', icon: faChartLine },
  { name: 'Chart Pie', key: 'faChartPie', icon: faChartPie },
  { name: 'Chess', key: 'faChess', icon: faChess },
  { name: 'Check', key: 'faCheck', icon: faCheck },
  { name: 'Child', key: 'faChild', icon: faChild },
  { name: 'Circle', key: 'faCircle', icon: faCircle },
  { name: 'Clipboard', key: 'faClipboard', icon: faClipboard },
  { name: 'Cloud', key: 'faCloud', icon: faCloud },
  { name: 'Cloud Rain', key: 'faCloudRain', icon: faCloudRain },
  { name: 'Cloud Sun', key: 'faCloudSun', icon: faCloudSun },
  { name: 'Cog', key: 'faCog', icon: faCog },
  { name: 'Coins', key: 'faCoins', icon: faCoins },
  { name: 'Compass', key: 'faCompass', icon: faCompass },
  { name: 'Couch', key: 'faCouch', icon: faCouch },
  { name: 'Credit Card', key: 'faCreditCard', icon: faCreditCard },
  { name: 'Cubes', key: 'faCubes', icon: faCubes },
  { name: 'Cut', key: 'faCut', icon: faCut },
  { name: 'Database', key: 'faDatabase', icon: faDatabase },
  { name: 'Desktop', key: 'faDesktop', icon: faDesktop },
  { name: 'Dice', key: 'faDice', icon: faDice },
  { name: 'Drum', key: 'faDrum', icon: faDrum },
  { name: 'Envelope', key: 'faEnvelope', icon: faEnvelope },
  { name: 'Eraser', key: 'faEraser', icon: faEraser },
  { name: 'Euro', key: 'faEuroSign', icon: faEuroSign },
  { name: 'Eye', key: 'faEye', icon: faEye },
  { name: 'Eye Slash', key: 'faEyeSlash', icon: faEyeSlash },
  { name: 'Fan', key: 'faFan', icon: faFan },
  { name: 'Fire Extinguisher', key: 'faFireExtinguisher', icon: faFireExtinguisher },
  { name: 'Fish', key: 'faFish', icon: faFish },
  { name: 'Flag', key: 'faFlag', icon: faFlag },
  { name: 'Flag Checkered', key: 'faFlagCheckered', icon: faFlagCheckered },
  { name: 'Flask', key: 'faFlask', icon: faFlask },
  { name: 'Folder', key: 'faFolder', icon: faFolder },
];

export const iconMap: Record<string, any> = availableIcons.reduce((acc, icon) => {
  acc[icon.key] = icon.icon;
  return acc;
}, {} as Record<string, any>);
